<template>
  <div class="withdrawal">
    <HeaderReturn title="提币">
      <template #right>
        <slot name="right">
          <van-icon
            name="todo-list-o"
            color="#f89b19"
            size="20"
            @click="goLink('/My/wecord')"
          />
        </slot>
      </template>
    </HeaderReturn>
    <!-- 币种 -->
    <div class="withdrawal_val">
      <p>选择币种</p>
      <!-- @change="changeRechareNet" -->
      <el-select
        @change="changeRechareNet"
        v-model="rechareForm.coinName"
        placeholder="请选择币种"
      >
        <el-option
          :label="item.coinName"
          :value="item.coinName"
          v-for="(item, index) in udunList"
          :key="index"
        ></el-option>
      </el-select>
      <div style="margin-top: 10px">
        <span>可用: {{ money }}</span>
      </div>
    </div>
    <!-- 可用 -->

    <!-- 地址 (TRC-20)-->
    <div class="withdrawal_val">
      <p>地址</p>
      <el-input v-model="rechareForm.addr" placeholder="请输入提币地址">
      </el-input>
    </div>
    <!-- 提币数量 -->
    <div class="withdrawal_val">
      <div style="display: flex; margin-top: 10px; color: #fff">
        提币数量 &nbsp;<span style="color: #f89b19">(手续费：{{ Fee }}％)</span>
      </div>

      <el-input
        @input="sdjha"
        v-model="rechareForm.amount"
        placeholder="请输入数量"
      >
        <template slot="suffix">
          <p class="d-flex" style="margin-top: 9px; font-size: 14px">
            {{ rechareForm.coinName }}
            <span
              style="margin: 0 10px; color: #f89b19"
              @click="rechareForm.amount = money"
            >
              全部</span
            >
          </p>
        </template>
      </el-input>
      <span style="padding-top: 10px">
        实际到账：
        <span style="color: #f89b19">
          {{ rechareForm.amount - rechareForm.amount * (Fee / 100) }}</span
        >
      </span>
    </div>
    <div class="shkjf" v-if="rechareForm.coinName == 'USDT'">
      <div class="withdrawal_val">
        <p>提现币种</p>
        <el-input disabled placeholder="LQD1"> </el-input>
        <div style="margin-top: 10px">
          <span>可用: {{ money2 }}</span>
        </div>
      </div>

      <div class="withdrawal_val">
        <p>地址</p>
        <el-input v-model="rechareForm.addr2"> </el-input>
      </div>
      <div class="withdrawal_val">
        <p>提币数量</p>
        <el-input disabled v-model="rechareForm.amount2"> </el-input>
      </div>
    </div>
    <!-- 交易密码 -->
    <div class="withdrawal_val">
      <p>交易密码</p>
      <el-input v-model="rechareForm.jyPassword" placeholder="请输入交易密码">
      </el-input>
    </div>
    <div class="withdrawal_btn" @click="Tj">
      <el-button>提交</el-button>
    </div>
    <div class="system_dialog">
      <el-dialog title="提示" :visible.sync="dialogVisible" width="90%">
        <div>
          此操作将向：
          <span style="color: #f89b19 !important; font-size: 15px"
            >{{ rechareForm.addr }} </span
          >的地址,提取 数量为 {{ rechareForm.amount }} 的
          {{ rechareForm.coinName }}
          {{
            rechareForm.coinName == "USDT"
              ? "和" +
                rechareForm.addr2 +
                "的地址提取 数量为" +
                rechareForm.amount2 +
                "的LQD1"
              : ""
          }}
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon } from "vant";
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
import { mainApiData } from "@/request/api.js";
import { linkWallet } from "../../../public/static/linkWallet.js";
import Web3 from "web3";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      baseApi: "",
      UrlYqhy: "",
      udunList: [
        {
          primaryNet: "USDT",
          coinName: "USDT",
        },
        {
          primaryNet: "LQD1",
          coinName: "LQD1",
        },
      ],
      rechareForm: {
        coinName: "USDT",
        addr: "",
        addr2: "",
        amount: "",
        amount2: "",
        jyPassword: "",
      },
      dialogVisible: false,
      money: 0,
      money2: 0,
      Fee: "",
    };
  },
  watch: {
    "rechareForm.coinName": function () {
      this.Init();
    },
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.Init();
  },
  methods: {
    sdjha(val) {
      console.log(val, "222");
      mainApiData
        .lastPrice({
          coinName: "LQD",
        })
        .then((res) => {
          this.rechareForm.amount2 = (
            this.rechareForm.amount /
            4 /
            res.data.data
          ).toFixed(3);
        });
    },
    qd() {
      mainApiData.userWithdraw(this.rechareForm).then((res) => {
        if (res.data.code == 200) {
          this.$toast("提币申请已提交");
          this.empty();
          this.dialogVisible = false;
        } else {
          this.$toast(res.data.msg);
          this.dialogVisible = false;
        }
      });
    },
    empty() {
      this.rechareForm.amount = "";
      this.rechareForm.amount2 = "";
      this.rechareForm.jyPassword = "";
      this.rechareForm.addr = "";
      this.rechareForm.addr2 = "";
      this.Init();
    },
    Tj() {
      if (this.rechareForm.amount == "" && this.rechareForm.amount == 0) {
        this.$toast("数量不能为空或者为0");
        return;
      }
      if (this.rechareForm.jyPassword == "") {
        this.$toast("交易密码不能为空");
        return;
      }
      if (this.rechareForm.addr == "") {
        this.$toast(this.rechareForm.coinName + "提币地址不能为空");
        return;
      }
      if (this.rechareForm.coinName == "USDT") {
        if (this.rechareForm.addr2 == "") {
          this.$toast("LQD1提币地址不能为空");
          return;
        }
      }
      this.rechareForm.coinName2 =
        this.rechareForm.coinName == "USDT" ? "LQD1" : "";
      this.dialogVisible = true;
      // linkWallet((bool, chainId, address) => {
      //   const web3 = new Web3(window.ethereum);
      //   web3.eth.personal.sign('TianYi', address, (err, sign) => {
      //     if (err != null) {

      //     }else{
      //       this.dialogVisible = true;
      //     }

      //   })
      // })
    },
    Init() {
      mainApiData
        .getAssetsByCoinName({
          coinName: this.rechareForm.coinName,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.money = res.data.data.usableBalance;
          }
        });
      mainApiData
        .getAssetsByCoinName({
          coinName: "LQD1",
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.money2 = res.data.data.usableBalance;
          }
        });
      mainApiData
        .getCoinByName({
          name: this.rechareForm.coinName,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.Fee = res.data.data.fee * 100;
          }
        });
    },
    changeRechareNet(coinName) {
      this.rechareForm.coinName = coinName;
    },
    onCopy() {
      this.$toast(this.$t("myself.a23"));
    },
    goLink(path) {
      if (path) {
        this.$router.push({
          path,
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

.withdrawal {
  margin: 50px 10px;
  ::v-deep .van-nav-bar__title {
    color: #f89b19;
    font-size: 20px;
    font-weight: 600;
  }
  .system_dialog {
    ::v-deep .el-dialog__wrapper {
      background: #090101;
      opacity: 0.8;
    }

    ::v-deep .el-input__inner {
      background: transparent;
      border: 0.5px solid #f89b19;

      border-radius: 4px;
      color: #fff;
    }

    ::v-deep .el-dialog,
    ::v-deep .el-button {
      background: #f89b19;

      color: #ffffff;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;

      border-radius: 4px;
    }

    ::v-deep .el-dialog {
      background: url(../../assets/img/page/TC-345X233.png) no-repeat;
      background-size: 100% 100%;
    }

    ::v-deep .el-dialog__title,
    ::v-deep .el-dialog__body {
      color: #ffffff;
      font-size: 12px;
    }
  }


  .withdrawal_selet {
    margin: 20px 0px 50px 0;
    width: 100%;

    // .el-select {
    //     width: 100%;

    //     background: rgba(20, 132, 195, 0.2);
    //     /* 黄/主题 */

    //     border: 0.5px solid #f89b19;
    //     box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25), inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
    //     border-radius: 4px;

    // }

    ::v-deep .el-input__inner {
      border: 0 !important;
      background: transparent !important;
      color: #fff;
    }
  }

  .withdrawal_qr {
    margin: 45px 0;
    text-align: center;
  }

  .withdrawal_dz {
    ::v-deep .el-input__inner {
      color: #fff;
      background: transparent;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;

      border-radius: 4px;
    }
  }

  .withdrawal_val {
    .el-select {
      width: 100%;

      // background:  linear-gradient(to bottom, transparent 0%, #f89b19 80%);
      /* 黄/主题 */

      // border: 0.5px solid #f89b19;
      // box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25), inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
      border-radius: 4px;
    }

    // margin: 30px 0;
    margin-bottom: 10px;

    p {
      margin: 0 0 10px 0;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;

      /* 白/FE */

      color: #fefefe;
    }

    span {
      display: flex;
      margin: 0 0 10px 0;
    }

    ::v-deep .el-input__inner {
      color: #fff;
      background: transparent;
      // background:  linear-gradient(to bottom, #f89b19 0%, #f89b19 80%);
      // background: linear-gradient(to bottom, #0074D9 0%, #0074D9 50%);
      border: 1px solid #f89b19;
      /* 黄/主题 */

      // box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25), inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
      border-radius: 4px;
    }
  }

  .withdrawal_btn {
    padding-top: 20px;
    padding-bottom: 40px;

    .el-button {
      width: 100%;
      background: #f89b19;
      border: 0;

      color: #fefefe;
    }
  }
}
</style>
